import { apiProductBenefits } from '@spo/services/api';
import { useQuery } from '@tanstack/react-query';

export const useProductBenefit = () => {
  return useQuery({
    queryKey: ['useProductBenefit'],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted) {
        const response = apiProductBenefits.getProductBenefits({
          language: 'EN',
        });
        return response;
      }
    },
  });
};
